export const getSafe = (path, obj) =>
  path.reduce((acc, key) => (acc && key in acc ? acc[key] : null), obj);

export const copyDeep = object => {
  return JSON.parse(JSON.stringify(object));
};

export const isString = value => {
  return typeof value === 'string' || value instanceof String;
};

export const convertCamelCaseToSpacedString = string => {
  return string.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
};

// os_name => OS Name
export const convertSnakeToCamelSnake = string => {
  let newWords = [];
  let words = string.split('_');
  words.forEach(word => {
    newWords.push(capitalizeFirstLetter(word));
  }); // Capitalize first letter of each word
  newWords[0] = newWords[0].toUpperCase();
  newWords = newWords.join(' ');
  return newWords;
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const camelCaseToSpacedString = camelCaseStr => {
  // Step 1: Insert a space before each uppercase letter (except the first one)
  const spacedStr = camelCaseStr.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Step 2: Capitalize the first letter of each word
  const result = spacedStr
    .split(' ') // Split the string into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
    .join(' '); // Join the words back into a string

  return result;
};

export const downloadFile = async (content, fileName, blobType) => {
  const blob = new Blob([content], {
    type: blobType,
  });
  const href = await URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const wt_decode = token => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export const formatDateTimeToDate = dateString => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0'); // Ensure day is two digits
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure month is two digits
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const isEmpty = obj => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};
